import { baseDarkTheme } from '~base-theme';
import modalTheme from './modalTheme';
var modalDarkTheme = {
  modal: Object.assign({}, modalTheme.modal, {
    backgroundColor: baseDarkTheme.base.colors.light,
    footer: {
      backgroundColor: baseDarkTheme.base.colors.light,
      dividerColor: baseDarkTheme.base.grays.grayLighter
    },
    overlay: {
      color: 'rgba(0, 0, 0, 0.75)'
    },
    closeIcon: {
      color: baseDarkTheme.base.grays.grayLight
    }
  })
};
export default modalDarkTheme;